import styled from '@emotion/styled';
import { TextInputGhost } from '@kc-console/common-ui';
import { useTranslation } from '@kc-console/core';
import { IcSearchRegular } from '@kep/kcds-icons';

import type { Dispatch, SetStateAction } from 'react';

interface Props {
  inputValue: string;
  setInputValue: Dispatch<SetStateAction<string>>;
}

const SearchInput = ({ inputValue, setInputValue }: Props) => {
  const { t } = useTranslation();
  return (
    <StyledSearchInput
      size={'md'}
      value={inputValue}
      autoComplete={'off'}
      onChange={e => setInputValue(e.target.value)}
      onClear={() => setInputValue('')}
      placeholder={t('layout:mega_menu.search.placeholder')}
      startAdornment={<IcSearchRegular />}
    />
  );
};

const StyledSearchInput = styled(TextInputGhost)(() => ({
  width: '100%',
  padding: '5.5px 8px',
  backgroundColor: 'transparent !important',

  '& .MuiInputBase-input': {
    padding: 0,
  },
  '&::before': {
    borderBottom: 'none !important',
  },
  '&::after': {
    borderBottom: 'none !important',
  },
}));

export default SearchInput;
